import React from 'react';

import '../../Step1/Question/Question.css';

const SLICE_SCORE_LABELS = [
    { x: '25%', y: '58%' },
    { x: '-30%', y: '57%' },
    { x: '-64%', y: '14%' },
    { x: '-50%', y: '-40%' },
    { x: '-1%', y: '-61%' },
    { x: '47%', y: '-36%' },
    { x: '59%', y: '17%' },
];

function formatSliceScore(score) {
    if (score == null || Number.isNaN(Number(score))) {
        return '';
    }
    const num = Number(score);
    const dec = String(num).split('.')[1];
    const places = dec && dec.length > 1 ? dec.length : 1;
    return num.toFixed(places);
}

const SlicesStep2 = (props) => {
    function sum(total) {
        total *= 10;

        total =
            total === 0 || total == null
                ? 0
                : total * 0.005 + (total >= 70 ? 0.55 : 0.44);

        return String(isNaN(total) ? 0 : total);
    }

    const isHighlighted =
        props.highlightIndex != null && props.index === props.highlightIndex;
    const isDimmed =
        props.highlightIndex != null && props.index !== props.highlightIndex;
    const sliceScale = sum(props.FullState.Fs[props.index].score);
    const highlightScale = isHighlighted ? 1.06 : 1;
    const labelIndex = Math.max(
        0,
        Math.min(
            SLICE_SCORE_LABELS.length - 1,
            (props.Fs?.areaId ?? props.index + 1) - 1
        )
    );
    const sliceScore = props.showSliceScores
        ? formatSliceScore(props.FullState.Fs[props.index]?.score)
        : '';

    const slices = (
        <g
            key={props.Fs.areaId}
            className={`selectGoalWheel__slice${
                isHighlighted ? ' selectGoalWheel__slice--active' : ''
            }${isDimmed ? ' selectGoalWheel__slice--dimmed' : ''}`}
            transform={
                props.Fs.areaId === 1
                    ? 'rotate(81.42,220,220)'
                    : `rotate(${132.84 + 51.42 * (props.index - 1)},220,220)`
            }
        >
            <g mask={`url(#${props.maskId || 'wedge-mask'})`}>
                <circle
                    className="Slice "
                    cx="220"
                    cy="220"
                    r="170"
                    fill={'white'}
                    style={{ transform: `scale(1.2)` }}
                />

                {props.FullState.CurrentF == -1 || props.allColors === true ? (
                    <circle
                        className="Slice selectGoalWheel__sliceFill"
                        cx="220"
                        cy="220"
                        r="170"
                        fill={props.FullState.Fs[props.index].color}
                        style={{
                            transform: `scale(${Number(sliceScale) * highlightScale})`,
                        }}
                    />
                ) : (
                    <circle
                        className="Slice selectGoalWheel__sliceFill"
                        cx="220"
                        cy="220"
                        r="170"
                        fill={
                            props.index === props.FullState.CurrentF
                                ? props.FullState.Fs[props.index].color
                                : '#c9c9c9'
                        }
                        style={{
                            transform: `scale(${sliceScale})`,
                        }}
                    />
                )}
                {sliceScore ? (
                    <text
                        className="selectGoalWheel__sliceScore"
                        x={SLICE_SCORE_LABELS[labelIndex].x}
                        y={SLICE_SCORE_LABELS[labelIndex].y}
                        fill="#ffffff"
                        aria-hidden="true"
                        style={{
                            transform:
                                props.Fs.areaId === 1
                                    ? 'rotate(-30deg)'
                                    : `rotate(${329.42 - 51.42 * props.index}deg)`,
                        }}
                    >
                        {sliceScore}
                    </text>
                ) : null}
            </g>
        </g>
    );

    return slices;
};

export default SlicesStep2;
